import {browserTimeZone} from '@sail/intl';
import type {IntlConfig, Locale} from '@sail/intl';
import {
  findSimilarLocale,
  calculateSupportedLocale,
} from './calculateSupportedLocale';
import {getLocaleData} from './getLocaleData';

const CONFIG_BY_LOCALE: Map<Locale, IntlConfig> = new Map();

export default async function getIntlConfig(
  preferredLocale?: string,
): Promise<IntlConfig> {
  const {matchedLocale: locale, source} =
    calculateSupportedLocale(preferredLocale);
  const similarLocaleMatch = findSimilarLocale(locale, source);

  if (CONFIG_BY_LOCALE.has(locale)) {
    return CONFIG_BY_LOCALE.get(locale)!;
  }

  // Attempt to merge the message set with one of a similar locale to have a more complete set of translations in case any are missing.
  const [localeData, similarLocaleData] = await Promise.all([
    getLocaleData(locale),
    getLocaleData(similarLocaleMatch?.matchedLocale),
  ]);

  const config: IntlConfig = {
    locale,
    timeZone: browserTimeZone,
    localeData: {
      ...localeData,
      messages: {
        ...similarLocaleData.messages,
        ...localeData.messages,
      },
    },
  };

  CONFIG_BY_LOCALE.set(locale, config);

  return config;
}
